/**
 * UGC / Marketing Studio contracts (E05): "Turn any product into a video ad
 * — in your customer's dialect." Wizard data is a validated document; the
 * pipeline compiles it into a JobGraph.
 */
import { z } from 'zod';
export const UGC_CATEGORIES = [
    'physical-product',
    'fashion',
    'packaged-goods',
    'software',
    'service',
    'expert',
];
/** Dialect routing keys (ADR-010): drive TTS voice, script style, lip-sync tier. */
export const DIALECTS = ['msa', 'khaleeji', 'egyptian', 'levantine', 'maghrebi', 'en'];
export const scriptLineSchema = z.object({
    key: z.string(), // hook | body-N | cta
    text: z.string().min(1).max(280),
    /** Visual direction for the scene behind this line. */
    visual: z.string().max(500),
});
export const ugcProjectDataSchema = z.object({
    category: z.enum(UGC_CATEGORIES).optional(),
    product: z
        .object({
        name: z.string().min(1).max(80),
        description: z.string().max(600).default(''),
    })
        .optional(),
    characterPresetId: z.string().optional(),
    dialect: z.enum(DIALECTS).optional(),
    locationPresetId: z.string().optional(),
    script: z.array(scriptLineSchema).max(8).optional(),
    export: z
        .object({
        aspect: z.enum(['9:16', '16:9', '1:1']).default('9:16'),
        quality: z.enum(['draft', 'final']).default('draft'),
        captions: z.boolean().default(true),
        captionStyleId: z.string().default('studio-default'),
    })
        .optional(),
});
//# sourceMappingURL=ugc.js.map